import { LabelData } from './label-data';

export class BaseInventoryLabelData extends LabelData {}
